import { api } from './client';
import type { SavedSearch } from '@/types/domain';

export async function fetchSavedSearches(): Promise<{ results: SavedSearch[] }> {
  return api.get('/saved-searches/me/');
}

export interface SavedSearchInput {
  name: string;
  filters: SavedSearch['filters'];
  delivery_mode: SavedSearch['delivery_mode'];
}

export async function createSavedSearch(input: SavedSearchInput): Promise<SavedSearch> {
  return api.post('/saved-searches/me/', { body: input });
}

export async function deleteSavedSearch(id: number): Promise<void> {
  await api.del(`/saved-searches/me/${id}/`);
}
